//eslint-disable-next-line
import React, { useEffect, useState } from "react";
//eslint-disable-next-line
import { checked, warning } from "assets/icons";
import {
  AppTable,
  //eslint-disable-next-line
  AppModal,
  //eslint-disable-next-line
  FormInput,
  //eslint-disable-next-line
  AppButton,
  //eslint-disable-next-line
  FormSelect,
  //eslint-disable-next-line
  Skeleton,
} from "components";
import { TableBodyContent } from "components/AppTable";
//import styled from "styled-components";
import moment from "moment";
import { AiOutlineArrowLeft } from "react-icons/ai";

function InstitutionUsers({ closeInstitution, data }) {
  return (
    <>
      <p
        style={{
          display: "flex",
          gap: "10px",
          color: "#04a3e5",
          fontSize: "17px",
          cursor: "pointer",
        }}
        onClick={() => {
          closeInstitution(false);
        }}
      >
        <AiOutlineArrowLeft size={20} /> Back
      </p>
      <AppTable
        tableHeadLength="5"
        titleB="Institution Users"
        columnWidth="220px"
        tableHead={[
          "Administrator name",
          "Administrator Phone",
          "Administrator Role",
          "Administrator Email",
          "DATE CREATED",
        ]}
        //searchInput={searchInput}
        pagination={false}
        btn={false}
        /*  childrenHead={
        <div>
          <SearchInput
            width="160%"
            onChange={(e) => {
              getInstitutions(
                `?search=${e.target.value || ""}&institutionType=${activeTab}`
              );
              setSearchInput(e.target.value);
            }}
          />
        </div>
      } */
      >
        <TableBodyContent>
          {data?.data?.users?.map((item, index) => {
            return (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: `repeat(5, 220px)`,
                  alignItems: "center",
                }}
                className="table_body_item"
              >
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  className="insName"
                >
                  {item?.name.slice(0, 8)}...
                </div>
                <div>{item?.phoneNumber || "-"}</div>
                <div>{item?.role || "-"}</div>
                <div className="email">
                  {item?.email?.slice(0, 10)}...{" "}
                  <span style={{ position: "absolute" }}>{item?.email}</span>{" "}
                </div>
                <div>
                  {moment(item?.dateCreated)
                    .subtract(1, "hours")
                    .format("DD-MM-YYYY hh:mm")}
                </div>
              </div>
            );
          })}
        </TableBodyContent>
      </AppTable>
    </>
  );
}

export default InstitutionUsers;
